<template>
	<Col :span="24">
		<VerticalLayout>
			<VRSSettingsForm />
			<RouteLeaveModal
				:visible="modalVisible"
				:confirm="modalOk"
				:cancel="modalCancel"
			/>
		</VerticalLayout>
	</Col>
</template>

<script>
import { Col } from 'ant-design-vue';

import RouteLeaveModal from '@/components/common/RouteLeaveModal';
import { useRouteLeaveModal } from '@/components/common/useRouteLeaveModal';

import VerticalLayout from '@/components/common/VerticalLayout';
import VRSSettingsForm from '@/components/settings/VRSSettingsForm';

import { useProvideInjectFormChangedStatuses } from '@/utils/useProvideInject';

export default {
	components: {
		Col,
		VerticalLayout, RouteLeaveModal,
		VRSSettingsForm,
	},
	setup() {
		const {
			formChangedStatuses,
			modalVisible,
			modalOk,
			modalCancel,
		} = useRouteLeaveModal();
		const { provideValue } = useProvideInjectFormChangedStatuses;
		provideValue(formChangedStatuses);
		return {
			modalVisible,
			modalOk,
			modalCancel,
		}
	},
}
</script>
